import { createFileRoute } from '@tanstack/react-router';

// The list alone, with no category open
export const Route = createFileRoute('/_authenticated/categories/')({});
